// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__2fShP","About_Title":"About_About_Title__2Yp1B","About_Description":"About_About_Description__S7JHJ"};